import { dasa } from './dasaClasses'
import { DasaIndexedDb } from './DasaIndexedDb';
export namespace test {
    export class DasaAppUtil {
        public static USER_TYPE_ARRAY = [
            { id: -1, name: 'Select User Type' },
            { id: dasa.Constant.USER_TYPE_BUSINESS_ADMIN, name: 'Vendor Admin' },
            { id: dasa.Constant.USER_TYPE_MANAGER, name: 'Manager' },
            { id: dasa.Constant.USER_TYPE_DRIVER, name: 'Driver' },
            { id: dasa.Constant.USER_TYPE_BOH, name: 'Back Of The House' },
            { id: dasa.Constant.USER_TYPE_FOH, name: 'Front Of The House' }
        ];

        //             ,{ id: dasa.Constant.USER_TYPE_BUSINESS_ADMIN_cum_STORE_ADMIN, name: 'Business Cum Store Admin' }

        public static getUserType(): any {
            if (dasa.Utility.loggedInUser.userGroupId == dasa.Constant.USER_TYPE_SUPER_ADMIN) {
                return DasaAppUtil.USER_TYPE_ARRAY;
            } else if (dasa.Utility.loggedInUser.userGroupId == dasa.Constant.USER_TYPE_BUSINESS_ADMIN || dasa.Utility.loggedInUser.userGroupId == dasa.Constant.USER_TYPE_STORE_ADMIN) {
                return [
                    { id: -1, name: 'Select User Type' },
                    { id: dasa.Constant.USER_TYPE_DRIVER, name: 'Driver' },
                    { id: dasa.Constant.USER_TYPE_BOH, name: 'Back Of The House' },
                    { id: dasa.Constant.USER_TYPE_FOH, name: 'Front Of The House' },
                    { id: dasa.Constant.USER_TYPE_MANAGER, name: 'Manager' }
                ];
            }
        }
        public static getCountryById(id: number): dasa.Country {
            let country: dasa.Country = {} as dasa.Country;
            for (let i = 0; i < dasa.Utility.countries.length; i++) {
                const element: dasa.Country = dasa.Utility.countries[i] as dasa.Country;
                if (element.id == id) {
                    country = dasa.Utility.countries[i];
                    break;
                }
            }

            return country;
        }

        /**
         * Method return gender string by code
         * @param genderCode 
         * @returns 
         */
        public static getGenderString(genderCode: string): string {
            let str: string = ""
            switch (genderCode) {
                case dasa.Constant.GENDER_MALE:
                    return 'Male';
                case dasa.Constant.GENDER_FEMALE:
                    return 'Female';
                case dasa.Constant.GENDER_TRANSGENDER:
                    return 'Transgender';
                default:
                    return "";
            }
        }

        public static orderStatusArray_pickup: any = [
            { id: dasa.Constant.ORDER_TYPE_PENDING, name: "Pending" },
            { id: dasa.Constant.ORDER_TYPE_ACCEPTED, name: "Accepted" },
            // { id: dasa.Constant.ORDER_TYPE_CANCELED, name: "Cancelled" },
            // { id: dasa.Constant.ORDER_TYPE_DELIVERED, name: "Delivered" },
            { id: dasa.Constant.ORDER_TYPE_READy_FOR_PICKUP, name: "Ready For Pick Up" },
            { id: dasa.Constant.ORDER_TYPE_PICKED, name: "Picked Up" },
           
            // { id: dasa.Constant.ORDER_TYPE_REJECTED, name: "Rejected" }
        ];

        public static orderStatusArray_delivered: any = [
            { id: dasa.Constant.ORDER_TYPE_PENDING, name: "Pending" },
            { id: dasa.Constant.ORDER_TYPE_ACCEPTED, name: "Accepted" },
            // { id: dasa.Constant.ORDER_TYPE_READy_FOR_PICKUP, name: "Ready For Pick Up" },
            { id: dasa.Constant.ORDER_TYPE_OUT_FOR_DELIVERY, name: "Driver on Its Way" },
            // { id: dasa.Constant.ORDER_TYPE_CANCELED, name: "Cancelled" },
            { id: dasa.Constant.ORDER_TYPE_DELIVERED, name: "Delivered" },
            // { id: dasa.Constant.ORDER_TYPE_PICKED, name: "Picked" },
            // { id: dasa.Constant.ORDER_TYPE_PROCESSING, name: "Processing" },
            // { id: dasa.Constant.ORDER_TYPE_REJECTED, name: "Rejected" }
        ];

        public static getOrderStatus(status: number): string {
            let str: string = ""
            switch (status) {
                case dasa.Constant.ORDER_TYPE_ACCEPTED:
                    return 'Accepted';
                case dasa.Constant.ORDER_TYPE_CANCELED:
                    // ORDER_TYPE_CANCELED (5) is the generic cancel code —
                    // used for pickup orders that vendors cancel, customer
                    // cancellations, and Stuart-cancelled deliveries alike.
                    // The old "Delivery canceled on Stuart" label was only
                    // correct for the third case and was misleading on the
                    // rest. Stuart-specific status text should only be set
                    // when the order actually has a Stuart job involved.
                    return 'Cancelled';
                case dasa.Constant.ORDER_TYPE_DELIVERED:
                    return 'Delivered';
                case dasa.Constant.ORDER_TYPE_PENDING:
                    return 'Pending';
                case dasa.Constant.ORDER_TYPE_PICKED:
                    return 'Picked Up';
                case dasa.Constant.ORDER_TYPE_PROCESSING:
                    return 'Accepted, Processing Delivery';
                case dasa.Constant.ORDER_TYPE_REJECTED:
                    return 'Rejected';
                case dasa.Constant.ORDER_TYPE_READy_FOR_PICKUP:
                    return 'Ready For Pick Up';
                case dasa.Constant.ORDER_TYPE_OUT_FOR_DELIVERY:
                    return 'Out for Delivery';
                    case dasa.Constant.ORDER_TYPE_SEARCHING_FOR_COURIER:
                        return 'Searching for Courier';
                case dasa.Constant.ORDER_TYPE_COURIER_ASSIGNED:
                    return 'Courier Assigned';
                case dasa.Constant.ORDER_TYPE_COURIER_ARRIVING_PICKUP:
                    return 'Courier Arriving to Pickup Food';
                case dasa.Constant.ORDER_TYPE_CUSTOMER_DROPOFF_IMMINENT:
                    return 'Customer Drop Off Imminent';
                case dasa.Constant.ORDER_TYPE_SCHEDULE_ACCEPTED:
                    return 'Accepted (Scheduled Order)';
                case dasa.Constant.ORDER_TYPE_CANCELLED_BY_VENDOR:
                    return 'Canceled by Vendor';
                case dasa.Constant.ORDER_TYPE_CANCELLED_BY_CUSTOMER:
                    return 'Canceled by Customer';
                default:
                    return "";
            }
        }
        /**
         * Make and return copy of an object
         * @param object
         * @returns 
         */
        public static getCopyOfAnObject(object: any): any {
            return JSON.parse(JSON.stringify(object));
        }

        /**
         * Method return User group string by userGroupId
         * @param userGroupId 
         * @returns 
         */
        public static getUserGroupString(userGroupId: number): string {
            switch (userGroupId) {
                case dasa.Constant.USER_TYPE_SUPER_ADMIN:
                    return 'Super Admin';
                case dasa.Constant.USER_TYPE_BUSINESS_ADMIN:
                    return 'Vendor Admin';
                case dasa.Constant.USER_TYPE_STORE_ADMIN:
                    return 'Vendor Admin';
                case dasa.Constant.USER_TYPE_DRIVER:
                    return 'Driver';
                // case dasa.Constant.USER_TYPE_BUSINESS_ADMIN_cum_STORE_ADMIN:
                //     return 'Business cum Super Admin';
                case dasa.Constant.USER_TYPE_MANAGER:
                    return 'Manager';
                case dasa.Constant.USER_TYPE_BOH:
                    return 'Back Of The House';
                case dasa.Constant.USER_TYPE_FOH:
                    return 'Front Of The House';
                case dasa.Constant.USER_TYPE_BARBER:
                    return 'Service Provider';


                default:
                    return '';
            }
        }
        public static getUser_StatusString(status: boolean): string {
            switch (status) {
                case true:
                    return 'Enabled';
                case false:
                    return 'Disabled';
                default:
                    return '';
            }
        }
        /**
         * Method used to get Status String
         */
        public static getStatusString(status: number): string {
            switch (status) {
                case dasa.Constant.STATUS_ENABLED:
                    return 'Enabled';
                case dasa.Constant.STATUS_DISABLED:
                    return 'Disabled';
                default:
                    return '';
            }
        }
        /**
         * 
         * @param deliveryType Method used to get deliveryType String
         */
        public static getDeliveryTypeString(deliveryType: number) {
            switch (deliveryType) {
                case dasa.Constant.DELIVERY_TYPE_PICK_UP_ONLY:
                    return 'Pickup only';
                case dasa.Constant.DELIVERY_TYPE_DELIVERY_ONLY:
                    return 'Delivery only';
                case dasa.Constant.DELIVERY_TYPE_PICKUP_DELIVERY_BOTH:
                    return 'Both';
                default:
                    return '';
            }
        }

        /**
         * Method used to get featured string
         */
        public static getFeaturedString(featuredType: number) {
            switch (featuredType) {
                case dasa.Constant.FEATURED_STORE_NO:
                    return 'No';
                case dasa.Constant.FEATURED_STORE_YES:
                    return 'Yes';
                default:
                    return '';
            }
        }



        /**
         * Method used to get user by user id
         * @param userId 
         * @returns 
         */
        public static getUserById(userId: number): dasa.User {
            let users: dasa.User[] = dasa.Utility.users;
            let u: any = {};
            if (users != undefined && users.length > 0) {
                for (let i: any = 0; i < users.length; i++) {
                    if (userId == users[i].id) {
                        u = users[i];
                        break;
                    }
                }
            }
            return u;
        }


        /**
         * Method used to get user by user id
         * @param userId 
         * @returns 
         */
        public static getBuisnessById(buisnessId: number): dasa.Business {
            let buisness: dasa.Business[] = dasa.Utility.businesses;
            let b: any = {};
            if (buisness != undefined && buisness.length > 0) {
                for (let i: any = 0; i < buisness.length; i++) {
                    if (buisnessId == buisness[i].id) {
                        b = buisness[i];
                        break;
                    }
                }
            }
            return b;
        }

        /**
         * Method used to get business by  id
         * @param userId 
         * @returns 
         */
        public static getBusinessItemById(itemId: number): dasa.User {
            let businessItems: dasa.StoreItem[] = dasa.Utility.businessItems;
            let u: any = {};
            if (businessItems != undefined && businessItems.length > 0) {
                for (let i: any = 0; i < businessItems.length; i++) {
                    if (itemId == businessItems[i].id) {
                        u = businessItems[i];
                        break;
                    }
                }
            }
            return u;
        }


        /**
         * Method used to get store by store id
         * @param userId 
         * @returns 
         */
        public static getStoreById(storeId: number): dasa.Store {
            let store: dasa.Store[] = dasa.Utility.stores;
            let b: any = {};
            if (store != undefined && store.length > 0) {
                for (let i: any = 0; i < store.length; i++) {
                    if (storeId == store[i].id) {
                        b = store[i];
                        break;
                    }
                }
            }
            return b;
        }
        /**
         * 
         * @param order_id Method used to get order by id
         */
        public static getOrderById(order_id: number): dasa.Order {
            let orders: any = dasa.Utility.storeOrders;
            let b: any = {};
            if (orders != undefined && orders.length > 0) {
                for (let i: any = 0; i < orders.length; i++) {
                    if (order_id == orders[i].order.id) {
                        b = orders[i];
                        break;
                    }
                }
            }
            return DasaAppUtil.getCopyOfAnObject(b) as dasa.Order;
        }



        /**
         * Method used to get user by user id
         * @param userId 
         * @returns 
         */
        public static getSupportById(supportId: number): dasa.SupportDetail {
            let support: dasa.SupportDetail[] = dasa.Utility.supportDetails;
            let b: any = {};
            if (support != undefined && support.length > 0) {
                for (let i: any = 0; i < support.length; i++) {
                    if (supportId == support[i].id) {
                        b = support[i];
                        break;
                    }
                }
            }
            return b;
        }


        /**
        * Method used to get Feedback type string
        * @param type
        * @returns 
        */
        public static getFeedbackType(type: number): string {
            let str: string = ""
            switch (type) {
                case dasa.Constant.FEEDBACK_TYPE_FEEDBACK:
                    return 'Feedback';
                case dasa.Constant.FEEDBACK_TYPE_SUGGESTION:
                    return 'Suggestion';
                case dasa.Constant.FEEDBACK_TYPE_COMPLAIN:
                    return 'Complain';
                default:
                    return "";
            }
        }
        /**
         * Method used to get Feedback status string
         * @param status 
         * @returns 
         */
        public static getFeedbackStatus(status: number): string {
            let str: string = ""
            switch (status) {
                case dasa.Constant.FEEDBACK_STATUS_CLOSED:
                    return 'Closed';
                case dasa.Constant.FEEDBACK_STATUS_OPEN:
                    return 'Open';
                default:
                    return "";
            }
        }



        /* get only enable brands list*/
        public static getEnableBrandsList() {
            let brands: dasa.Brand[] = dasa.Utility.brands;
            let disabledBrandIds = [];
            if (dasa.Utility.storeSettings != undefined && dasa.Utility.storeSettings.disabledBrandIds != undefined)
                disabledBrandIds = dasa.Utility.storeSettings.disabledBrandIds;
            let b: any = [];
            if (disabledBrandIds != undefined && disabledBrandIds.length > 0) {
                if (brands != undefined && brands.length > 0) {
                    for (let i: any = 0; i < brands.length; i++) {
                        let isDisabled: boolean = false;
                        for (let k: any = 0; k < disabledBrandIds.length; k++) {
                            if (disabledBrandIds[k] == brands[i].id) {
                                isDisabled = true;
                                break;
                            }
                        }
                        if (isDisabled == false) {
                            b[b.length] = brands[i];
                        }

                    }
                }
            } else {
                b = brands;
            }
            // console.log('getEnableBrandsList', brands)
            return this.getCopyOfAnObject(b);
        }

        /* get only enable category list*/
        public static getEnableCategoryList() {
            let categories: dasa.Category[] = dasa.Utility.categories;
            let disabledCategoryIds = [];
            if (dasa.Utility.storeSettings != undefined && dasa.Utility.storeSettings.disabledBrandIds != undefined)
                disabledCategoryIds = dasa.Utility.storeSettings.disabledCategoryIds;
            let b: any = [];
            if (disabledCategoryIds != undefined && disabledCategoryIds.length > 0) {
                if (categories != undefined && categories.length > 0) {
                    for (let i: any = 0; i < categories.length; i++) {
                        let isDisabled: boolean = false;
                        for (let k: any = 0; k < disabledCategoryIds.length; k++) {
                            if (disabledCategoryIds[k] == categories[i].id) {
                                isDisabled = true;
                                break;
                            }
                        }
                        if (isDisabled == false) {
                            b[b.length] = categories[i];
                        }

                    }
                }
            } else {
                b = categories;
            }
            // console.log('getEnableBrandsList', categories)
            return this.getCopyOfAnObject(b);
        }

        public static getBrandById(brandId: number): dasa.Brand {
            let brands: dasa.Brand[] = dasa.Utility.brands;
            let brand: dasa.Brand = {} as dasa.Brand;
            if (brands != undefined && brands.length > 0) {
                brands.forEach(element => {
                    if (element.id == brandId) {
                        brand = element;

                    }

                });
            }

            return DasaAppUtil.getCopyOfAnObject(brand) as dasa.Brand;
        }

        public static getCategoryById(categoryId: number): dasa.Category {
            let categories: dasa.Category[] = dasa.Utility.categories;
            let category: dasa.Category = {} as dasa.Category;
            if (categories != undefined && categories.length > 0) {
                categories.forEach(element => {
                    if (element.id == categoryId) {
                        category = element;

                    }

                });
            }

            return DasaAppUtil.getCopyOfAnObject(category) as dasa.Category;
        }



        /* get only enable store item list*/
        public static getEnableStoreItemList() {
            let storeItems: dasa.StoreItem[] = dasa.Utility.storeItems;
            let disabledItemIds = [];
            if (dasa.Utility.storeSettings != undefined && dasa.Utility.storeSettings.disabledItemIds != undefined)
                disabledItemIds = dasa.Utility.storeSettings.disabledItemIds;
            let b: any = [];
            if (disabledItemIds != undefined && disabledItemIds.length > 0) {
                if (storeItems != undefined && storeItems.length > 0) {
                    for (let i: any = 0; i < storeItems.length; i++) {
                        let isDisabled: boolean = false;
                        for (let k: any = 0; k < disabledItemIds.length; k++) {
                            if (disabledItemIds[k] == storeItems[i].id) {
                                isDisabled = true;
                                break;
                            }
                        }
                        if (isDisabled == false && this.isDisabledBrand(storeItems[i].brandId) == false
                            && this.isDisabledCategory(storeItems[i].categoryId) == false) {
                            b[b.length] = storeItems[i];
                        }

                    }
                }
            } else {
                b = storeItems;
            }
            // console.log('getEnableBrandsList', storeItems)
            return this.getCopyOfAnObject(b);
        }

        public static getItemById(itemId: number): dasa.StoreItem {
            let item: dasa.StoreItem[] = dasa.Utility.storeItems;
            let b: any = {};
            if (item != undefined && item.length > 0) {
                for (let i: any = 0; i < item.length; i++) {
                    if (itemId == item[i].id) {
                        b = item[i];
                        break;
                    }
                }
            }
            return this.getCopyOfAnObject(b);
        }

        public static isDisabledCategory(categoryId: number): boolean {
            let isDisabled: boolean = false;
            let categories: any = dasa.Utility.categories;
            let disabledCategoryIds = dasa.Utility.storeSettings.disabledCategoryIds;
            if (disabledCategoryIds != undefined && disabledCategoryIds.length > 0) {
                for (let i = 0; i < disabledCategoryIds.length; i++) {
                    if (disabledCategoryIds[i] * 1 == categoryId * 1) {
                        isDisabled = true;
                        break;
                    }
                }
            }

            return isDisabled;
        }

        public static isDisabledBrand(brandId: number): boolean {
            let isDisabled: boolean = false;
            let brands: any = dasa.Utility.brands;
            let disabledBrandIds = dasa.Utility.storeSettings.disabledBrandIds;
            if (disabledBrandIds != undefined && disabledBrandIds.length > 0) {
                for (let i = 0; i < disabledBrandIds.length; i++) {
                    if (disabledBrandIds[i] * 1 == brandId * 1) {
                        isDisabled = true;
                        break;
                    }
                }
            }

            return isDisabled;
        }
        public static getUserStatusArray(): any {
            let status_data = [
                {
                    id: -1,
                    status: 'Select Status'
                },
                {
                    id: 1,
                    status: 'Enabled'
                }, {
                    id: 0,
                    status: 'Disabled'
                }
            ];
            return status_data;
        }


        public static getStatusArray(): any {
            let status_data = [
                {
                    id: -1,
                    status: 'Select Status'
                },
                {
                    id: dasa.Constant.STATUS_ENABLED,
                    status: 'Enabled'
                }, {
                    id: dasa.Constant.STATUS_DISABLED,
                    status: 'Disabled'
                }
            ];
            return status_data;
        }

        /*
        Get user type buisness or buisness cum store admin
        */

        public static getUserTypeArray(): any {
            let usertype_data = [
                {
                    id: -1,
                    name: 'Select User Type'
                },
                {
                    id: dasa.Constant.USER_TYPE_BUSINESS_ADMIN,
                    name: 'Business Admin'
                }, {
                    id: dasa.Constant.USER_TYPE_BUSINESS_ADMIN_cum_STORE_ADMIN,
                    name: 'Business Cum Super Admin'
                }
            ];
            return usertype_data;
        }

        /*
        Get timingjson data
        */
        public static getTimingJson(): any {
            let timing_data = [
                { id: 1, day: "Monday", openingTime: "09:00", closingTime: "20:00" },
                { id: 2, day: "Tuesday", openingTime: "09:00", closingTime: "20:00" },
                { id: 3, day: "Wednesday", openingTime: "09:00", closingTime: "20:00" },
                { id: 4, day: "Thursday", openingTime: "09:00", closingTime: "20:00" },
                { id: 5, day: "Friday", openingTime: "09:00", closingTime: "20:00" },
                { id: 6, day: "Saturday", openingTime: "09:00", closingTime: "20:00" },
                { id: 7, day: "Sunday", openingTime: "09:00", closingTime: "20:00" },


            ];
            return timing_data;
        }

        public static getTimeObjectCurrentDay(storeTime: any[]): any {
            let day_value = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            let curr_date = new Date();
            let get_data = storeTime.filter(itm => itm.day === day_value[curr_date.getUTCDay()]);
            return get_data;
        }

        // public static getdRangeJson():any{
        //     let dRangeJson_data =[
        //         {startRange: "1",  endRange: "2", deliveryTime: "3"}
        //     ];
        //     return dRangeJson_data;

        // }

        /*
       Get dRangeJson data
       */
        public static getdRangeJson(): any {
            let timing_data = [
                { startRange: "", endRange: "", deliveryTime: "" },


            ];
            return timing_data;
        }

        /* Method to get is featured data */
        public static getIsFeaturedArray(): any {
            let isFeatured_data = [
                {
                    id: -1,
                    status: 'Select Featured Store'
                },
                {
                    id: dasa.Constant.FEATURED_STORE_YES,
                    status: 'Yes'
                },
                {
                    id: dasa.Constant.FEATURED_STORE_NO,
                    status: 'No'
                }
            ];
            return isFeatured_data;
        }


        /** 
         * Method to get delivery type
        **/

        public static getDeliveryTypeArray(): any {
            let deliverytype_data = [
                {
                    id: -1,
                    status: 'Select Delivery Type'
                },
                {
                    id: dasa.Constant.DELIVERY_TYPE_PICK_UP_ONLY,
                    status: 'Pick Up Only'
                },
                {
                    id: dasa.Constant.DELIVERY_TYPE_DELIVERY_ONLY,
                    status: 'Delivery Only'
                },
                {
                    id: dasa.Constant.DELIVERY_TYPE_PICKUP_DELIVERY_BOTH,
                    status: 'Pickup and Delivery'
                }

            ];
            return deliverytype_data;
        }

        /* Method to get is featured data */
        public static getDiscountTypeArray(): any {
            let discountType_data = [
                {
                    id: -1,
                    name: 'Select Discount Type'
                },
                {
                    id: dasa.Constant.DISCOUNT_TYPE_FLAT,
                    name: 'Flat'
                },
                {
                    id: dasa.Constant.DISCOUNT_TYPE_PERCENT,
                    name: 'Percent'
                }
            ];
            return discountType_data;
        }

        /*
        Get Discount type flat & percent
        */

        public static getDiscountType(id: number) {
            let value;
            if (id === dasa.Constant.DISCOUNT_TYPE_PERCENT) {
                value = "Percent";
            }
            else if (id === dasa.Constant.DISCOUNT_TYPE_FLAT) {
                value = "Flat";
            }
            return value;
        }

        /* Get CMS type  and passed type in function
        */

        public static getCMSType(id: number) {
            let value;
            if (id === 1) {
                value = "Driver";
            }
            else if (id === 2) {
                value = "Store";
            }
            else if (id === 3) {
                value = "Customer";
            }

            return value;
        }

        /*get unit type*/

        public static getUnitArray(): any {
            let unit_data = [
                {
                    id: -1,
                    name: 'Select Unit'
                },
                {
                    id: 1,
                    name: 'Kg'
                },
                {
                    id: 2,
                    name: 'Gm'
                },
                {
                    id: 3,
                    name: 'Ltrs'
                }
            ];
            return unit_data;
        }

        /**
         * Method used to get user by user id
         * @param userId 
         * @returns 
         */
        public static getUnitNameByID(unitId: number): string {
            let arry = this.getUnitArray();
            let unitName = "";
            for (let i: any = 0; i < arry.length; i++) {
                if (unitId == arry[i].id) {
                    unitName = arry[i].name;
                    break;
                }
            }
            return unitName;
        }
  public static async putInSession(): Promise<void> {
    if (!(window && window.sessionStorage)) {
        return;
    }

    // Never overwrite a good session with an empty user.
    //
    // putInSession is called from ~87 places, and any one of them that runs
    // before the session has been restored persists `loggedInUser: {}` over
    // the real one. The damage only shows on the NEXT load: the header calls
    // isUserLoggedIn(), sees no id, and calls removeFromSession() + redirects.
    // That is the "refreshing twice logs the vendor out" report — the first
    // refresh clobbers the session, the second acts on it.
    //
    // If we have no valid user in memory but sessionStorage still holds one,
    // the in-memory state is the stale side, so leave the stored session alone.
    const hasLiveUser = !!(dasa.Utility.loggedInUser && (dasa.Utility.loggedInUser as any).id > 0);
    if (!hasLiveUser) {
        try {
            const existing = sessionStorage.getItem("dasaSession");
            if (existing) {
                const stored = JSON.parse(existing);
                if (stored?.loggedInUser?.id > 0) {
                    return;
                }
            }
        } catch { /* unreadable session — fall through and rewrite it */ }
    }

    const lightSession = {
        loggedInUser: dasa.Utility.loggedInUser || {},
        selectedBusinessId: dasa.Utility.selectedBusinessId,
        selectedStoreId: dasa.Utility.selectedStoreId,
        selectedCountry: dasa.Utility.selectedCountry || {},
        socketId: dasa.Utility.socketId || "",
        latitude: dasa.Utility.latitude,
        longitude: dasa.Utility.longitude,
        selectedCompanyId: dasa.Utility.selectedCompanyId,
        apiToken: dasa.Utility.apiToken || "",
        serviceProviderId: dasa.Utility.serviceProviderId
    };

    try {
        // keep only lightweight data in sessionStorage
        sessionStorage.setItem("dasaSession", JSON.stringify(lightSession));

        // Move large data to IndexedDB in a SINGLE transaction. This used to be
        // 19 parallel set() calls, each opening and closing its own connection
        // and re-cloning data that had not changed since boot.
        await DasaIndexedDb.setMany({
            businesses: dasa.Utility.businesses || [],
            countries: dasa.Utility.countries || [],
            supportDetails: dasa.Utility.supportDetails || [],
            users: dasa.Utility.users || [],
            stores: dasa.Utility.stores || [],
            complains: dasa.Utility.complains || [],

            brands: dasa.Utility.brands || [],
            categories: dasa.Utility.categories || [],
            storeItems: dasa.Utility.storeItems || [],
            storeSettings: dasa.Utility.storeSettings || {},
            storeConfigurations: dasa.Utility.storeConfigurations || {},

            businessItems: dasa.Utility.businessItems || [],
            storeOrders: dasa.Utility.storeOrders || [],
            myReportData: dasa.Utility.myReportData || {},

            selectedCustomerForReport: dasa.Utility.selectedCustomerForReport,
            selectedCountryForReport: dasa.Utility.selectedCountryForReport,
            selectedBusinessForReport: dasa.Utility.selectedBusinessForReport,
            selectedStoreForReport: dasa.Utility.selectedStoreForReport,

            carts: dasa.Utility.carts || [],

            selectedType: dasa.Utility.selectedType || {}
        });

        // remove old huge session key if it exists
        sessionStorage.removeItem("dasaDb");
    } catch (error) {
        console.error("Failed to persist app state.", error);
    }
}

public static async loadFromSession(): Promise<void> {
    if (!(window && window.sessionStorage)) {
        return;
    }

    try {
        const raw = sessionStorage.getItem("dasaSession");

        if (raw) {
            const s = JSON.parse(raw);

            dasa.Utility.loggedInUser = s.loggedInUser || {};
            dasa.Utility.selectedBusinessId = typeof s.selectedBusinessId === 'number' ? s.selectedBusinessId : -1;
            dasa.Utility.selectedStoreId = typeof s.selectedStoreId === 'number' ? s.selectedStoreId : -1;
            dasa.Utility.selectedCountry = s.selectedCountry || {} as any;
            dasa.Utility.socketId = s.socketId || "";
            dasa.Utility.latitude = typeof s.latitude === 'number' ? s.latitude : -1;
            dasa.Utility.longitude = typeof s.longitude === 'number' ? s.longitude : -1;
            // Defaults to -1 (Combined) for sessions saved before this feature.
            dasa.Utility.selectedCompanyId = typeof s.selectedCompanyId === 'number' ? s.selectedCompanyId : -1;
            // Empty for sessions saved before the vendor API token existed; the
            // payment-credential screens then prompt for a fresh login.
            dasa.Utility.apiToken = typeof s.apiToken === 'string' ? s.apiToken : "";
            dasa.Utility.serviceProviderId = typeof s.serviceProviderId === 'number' ? s.serviceProviderId : -1;
        }

        // One transaction, one connection — was 20 separate opens.
        const results = await DasaIndexedDb.getMany([
            "businesses", "countries", "supportDetails", "users", "stores",
            "complains", "brands", "categories", "storeItems", "storeSettings",
            "storeConfigurations", "businessItems", "storeOrders", "myReportData",
            "selectedCustomerForReport", "selectedCountryForReport",
            "selectedBusinessForReport", "selectedStoreForReport",
            "carts", "selectedType"
        ]);

        dasa.Utility.businesses = results[0] || [];
        dasa.Utility.countries = results[1] || [];
        dasa.Utility.supportDetails = results[2] || [];
        dasa.Utility.users = results[3] || [];
        dasa.Utility.stores = results[4] || [];
        dasa.Utility.complains = results[5] || [];

        dasa.Utility.brands = results[6] || [];
        dasa.Utility.categories = results[7] || [];
        dasa.Utility.storeItems = results[8] || [];
        dasa.Utility.storeSettings = results[9] || {};
        dasa.Utility.storeConfigurations = results[10] || {};

        dasa.Utility.businessItems = results[11] || [];
        dasa.Utility.storeOrders = results[12] || [];
        dasa.Utility.myReportData = results[13] || {} as any;

        dasa.Utility.selectedCustomerForReport = results[14] != null ? results[14] : 0;
        dasa.Utility.selectedCountryForReport = results[15] != null ? results[15] : 0;
        dasa.Utility.selectedBusinessForReport = results[16] != null ? results[16] : 0;
        dasa.Utility.selectedStoreForReport = results[17] != null ? results[17] : 0;
        // getMany's key list ends ... selectedStoreForReport(17), carts(18),
        // selectedType(19). This read index 18, so selectedType silently took
        // the carts array.
        dasa.Utility.selectedType = results[19] != null ? results[19] : 0;

        

        dasa.Utility.carts = results[18] || [];
    } catch (error) {
        console.error("Failed to load app state.", error);
    }
}

public static async removeFromSession(): Promise<void> {
    if (window && window.sessionStorage) {
        sessionStorage.removeItem("dasaDb");
        sessionStorage.removeItem("dasaSession");
    }

    try {
        await DasaIndexedDb.clear();
    } catch (error) {
        console.error("Failed to clear IndexedDB.", error);
    }

    dasa.Utility.businesses = [];
    dasa.Utility.countries = [];
    dasa.Utility.loggedInUser = {};
    dasa.Utility.supportDetails = [];
    dasa.Utility.users = [];
    dasa.Utility.stores = [];
    dasa.Utility.selectedBusinessId = -1;
    dasa.Utility.selectedStoreId = -1;
    dasa.Utility.serviceProviderId = -1;
    dasa.Utility.brands = [];
    dasa.Utility.categories = [];
    dasa.Utility.storeItems = [];
    dasa.Utility.storeSettings = {};
    dasa.Utility.businessItems = [];
    dasa.Utility.storeOrders = [];
    dasa.Utility.complains = [];
    dasa.Utility.selectedCountry = {} as any;
    dasa.Utility.carts = [];
    dasa.Utility.myReportData = {} as any;
    dasa.Utility.selectedCustomerForReport = 0;
    dasa.Utility.selectedCountryForReport = 0;
    dasa.Utility.selectedBusinessForReport = 0;
    dasa.Utility.selectedStoreForReport = 0;
    dasa.Utility.storeConfigurations = {} as any;
    dasa.Utility.socketId = "";
    dasa.Utility.latitude = -1;
    dasa.Utility.longitude = -1;
    dasa.Utility.selectedType = -1;
    // Back to Combined, so a new session never inherits the previous
    // operator's company scope.
    dasa.Utility.selectedCompanyId = -1;
}

        public static getPromoCodeById(id: any) {
            console.log(dasa.Utility.promoCodesList)
            const promoCode =  dasa.Utility.promoCodesList.find((x: any) => x.id == id);
            return promoCode;
        }


    }
    /**
    * All fields present in this class will be stored in session
    */
    export class SessionObject {
        public loggedInUser: any = {};
        public countries: any = [];
        public businesses: any = [];
        public supportDetails: any = [];
        public users: any = [];
        public stores: any = [];
        public selectedBusinessId: number = -1;
        public selectedStoreId: number = -1;
        public businessItems: any = [];
        public selectedCountry: dasa.Country = {} as dasa.Country;
        public complains: dasa.FeedbackComplain[] = [] as dasa.FeedbackComplain[];

        public storeSettings: any = {};
        public storeConfigurations: dasa.StoreConfiguration = {} as dasa.StoreConfiguration;

        public brands: any = [];
        public categories: any = [];
        public storeItems: any = [];
        public storeOrders: dasa.Order[] = [] as dasa.Order[];
        public carts: dasa.Cart[] = [] as dasa.Cart[]
        public myReportData: dasa.myReportData = {} as dasa.myReportData;
        public socketId: string = "";
        public latitude: number = -1;
        public longitude: number = -1;
        public selectedCustomerForReport: number = -1;
        public selectedCountryForReport: number = -1;
        public selectedBusinessForReport: number = -1;
        public selectedStoreForReport: number = -1;
        /**
         * Two-company split reporting: which company the dashboard is currently
         * scoped to. -1 means "Combined" (the whole restaurant), which is the
         * default and matches how the app behaved before the feature existed.
         * Only meaningful when storeConfigurations.splitReports is on.
         */
        public selectedCompanyId: number = -1;
        /**
         * Default constructor
         */
        constructor() {

        }
    }



}